import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { environment } from "@env/environment";
import { MsalGuard } from "@azure/msal-angular";

import { DefaultLayoutComponent } from "./layout/default-layout/default-layout.component";
import { HomeComponent } from "./components/home/home.component";
import { UserInfoComponent } from './components/core/user-info/user-info.component';
import { AppInfoComponent } from "./components/core/app-info/app-info/app-info.component";
import { UserAdministrationComponent } from "./components/admin/user-management/user-administration.component";
import { AdminFunctionsComponent } from "./components/admin/admin-functions/admin-functions.component";
import { AuthGuard } from "./auth/auth.guard";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { FirmComponent } from "./components/firm/firm.component";
import { FirmApplicationListComponent } from "./components/application/firm/firm-application-list.component";
import { IndividualApplicationListComponent } from "./components/application/individual/individual-application-list.component";
import { IndividualComponent } from "./components/individual/individual.component";
import { AtpComponent } from "./components/atp/atp.component";
import { ComplaintComponent } from "./components/complaint/complaint.component";
import { AtpStudentComponent } from "./components/atp/atp-student/atp-student.component";
import { PaymentDashboardComponent } from "./components/payments/components/dashboard/payment-dashboard.component";
import { ReportsComponent } from "./components/reports/reports-voucher.component";
import { AtpCourseComponent } from "./components/atp/atp-course/atp-course.component";
import { CalltrackerHomeComponent } from "./components/calltracker/calltrackerHome.component";
import { MetricsComponent } from "./components/calltracker/metrics/metrics.component";
import { AtpApplicationListComponent } from "./components/application/atp/atp-application-list.component";
import { PendingAccessUpdatesComponent } from "./components/reports/pending-access-updates/pending-access-updates.component";

const routes: Routes = [
  {
    path: "",
    component: DefaultLayoutComponent,
    canActivate: environment.authEntireSite ? [MsalGuard] : [],
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      { path: "dashboard", component: DashboardComponent, canActivate: [ MsalGuard ]},
      { path: "profile", component: UserInfoComponent, canActivate: [ MsalGuard ]},
      { path: "admin/user-management", component: UserAdministrationComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "admin/admin-functions", component: AdminFunctionsComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "user-management", redirectTo: "admin/user-management", pathMatch: "full" },
      { path: "atp/management", component: AtpComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "atp/students", component: AtpStudentComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "atp/courses", component: AtpCourseComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "atp/applications", component: AtpApplicationListComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "firm/management", component: FirmComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "firm/applications", component: FirmApplicationListComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "individual/management", component: IndividualComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "individual/applications", component: IndividualApplicationListComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "complaint/list", component: ComplaintComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "payments", component: PaymentDashboardComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "app-info", component: AppInfoComponent},
      { path: "home", component: HomeComponent },
      { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard]  },
      { path: 'pending-access-updates', component: PendingAccessUpdatesComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "calltracker/inquiries", component: CalltrackerHomeComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},
      { path: "calltracker/metrics", component: MetricsComponent, canActivate: [ MsalGuard, AuthGuard ], data: { roles: ['Admin']}},      
      {
        path: "sessions",
        loadChildren: () => import("./components/sessions/sessions.module").then((m) => m.SessionsModule),
      },
    ],
  },
  { path: "**", redirectTo: "home" },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled",
      relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
  declarations: [],
})
export class RoutesRoutingModule {}
